import { render, staticRenderFns } from "./TagTip.vue?vue&type=template&id=0c343daa&scoped=true&"
import script from "./TagTip.vue?vue&type=script&lang=js&"
export * from "./TagTip.vue?vue&type=script&lang=js&"
import style0 from "./TagTip.vue?vue&type=style&index=0&id=0c343daa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c343daa",
  null
  
)

export default component.exports